import { COUPONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import couponsTypes from '../../constants/couponsTypes'
import { axios } from '../../services'

// 1 delete
const delete_coupon_request = () => {
  return {
    type: couponsTypes.publish.request
  }
}

const delete_coupon_success = (response) => {
  return {
    type: couponsTypes.publish.success,
    payload: response.data
  }
}

const delete_coupon_failure = (messages) => {
  if (messages.constructor === Array) {
    window.showSnackbar('error', messages.join("\n"))
  }
  return {
    type: couponsTypes.publish.failure,
    payload: messages
  }
}

const delete_coupon = (coupon_id, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( delete_coupon_request() )
    const reqParams = {
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    }
    // Request
    axios.delete(
      formatRoute(COUPONS_ROUTES.destroy, {id: coupon_id}),
      {
        params: reqParams
      }
    ).then( response => {
      window.showSnackbar('success', 'The coupon has been permanently deleted.')
      dispatch( delete_coupon_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error deleting coupon"]
      }
      dispatch( delete_coupon_failure( errors ) )
    })
  }
}

export {delete_coupon}



// WEBPACK FOOTER //
// ./src/js/actions/coupons/delete.js